
export const onlyNumbers = (event) => {
  const char = String.fromCharCode(event.which);
  if (!/[0-9]/.test(char)) {
    event.preventDefault();
  }
}


export const numberDecimal = (event, maxIntegers = 7, maxDecimals = 4) => {
  const char = String.fromCharCode(event.which);
  const { value } = event.target;

  // Expresión regular para permitir hasta 2 enteros y 2 decimales
  const regex = new RegExp(`^\\d{0,${maxIntegers}}(\\.\\d{0,${maxDecimals}})?$`);

  // Crear un nuevo valor para verificar
  const newValue = value + char;

  // Comprobar si el carácter es un número o un punto
  if (!/[0-9.]/.test(char) || (char === '.' && value.includes('.'))) {
    event.preventDefault(); // Evitar caracteres no permitidos
  } else if (!regex.test(newValue)) {
    event.preventDefault(); // Evitar valores que no cumplen con la regex
  }
}
